/**
 * Canonical Brand Manager (Client / global control plane) paths.
 *
 * Account (My Profile / Security / Company / Payment) is global-only → BM.
 * User Management exists at BOTH planes over one SOR:
 *   - Brand Manager → portfolio/client-wide UM
 *   - Brand shell → active-Brand-scoped UM
 */

export const BM_ACCOUNT_BASE = "/brand-manager/account";
export const BM_ACCOUNT_SECURITY = "/brand-manager/account/security";
export const BM_ACCOUNT_COMPANY = "/brand-manager/account/company";
export const BM_ACCOUNT_PAYMENT = "/brand-manager/account/payment";
export const BM_USER_MANAGEMENT_USERS = "/brand-manager/user-management/users";
export const BM_USER_MANAGEMENT_ROLES = "/brand-manager/user-management/roles";
export const BM_BRAND_REQUESTS = "/brand-manager/brand-requests";
export const BM_ANALYTICS = "/brand-manager/analytics";
export const BM_REPORTS = "/brand-manager/reports";
export const BM_SETTINGS = "/brand-manager/settings";
export const BM_ADD_BRAND = "/brand-manager/add-brand";

const LEGACY_ACCOUNT_PREFIX = "/master-account/account";

/**
 * Clients host global Account in Brand Manager.
 * Vendors keep Account in the Master Account shell.
 */
export function hostsGlobalAccountInBrandManager(kind) {
  const k = kind || "client";
  return k === "client";
}

/**
 * Remap legacy brand-shell Account URLs to Brand Manager.
 * User Management is intentionally NOT remapped — Brand-scoped UM stays
 * at /master-account/user-management/* alongside BM global UM.
 */
export function toBrandManagerGlobalPath(pathname = "") {
  const path = String(pathname || "");
  if (path === LEGACY_ACCOUNT_PREFIX || path.startsWith(`${LEGACY_ACCOUNT_PREFIX}/`)) {
    return path.replace(/^\/master-account/, "/brand-manager");
  }
  return null;
}

export function isBrandManagerAccountPath(pathname = "") {
  const path = String(pathname || "");
  return path === BM_ACCOUNT_BASE || path.startsWith(`${BM_ACCOUNT_BASE}/`);
}

export function isBrandManagerUserManagementPath(pathname = "") {
  const path = String(pathname || "");
  return (
    path === "/brand-manager/user-management" ||
    path.startsWith("/brand-manager/user-management/") ||
    path === "/brand-manager/users"
  );
}

export function isBrandShellUserManagementPath(pathname = "") {
  const path = String(pathname || "");
  return (
    path === "/master-account/user-management" ||
    path.startsWith("/master-account/user-management/")
  );
}
